export default "__VITE_ASSET__BtBrtvEI__"